import styled from "styled-components";

export const UnauthenticatedContainer = styled.div.attrs({
})` 
    width: min(100%, 440px);
    background:
        linear-gradient(180deg, ${props => props.theme.palette.colors.surfaceElevated} 0%, ${props => props.theme.palette.colors.surfaceElevatedStrong} 100%);
    border: 1px solid ${props => props.theme.palette.colors.borderStrong};
    box-shadow: 0 24px 70px ${props => props.theme.palette.colors.shadowStrong};
    padding: 44px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 22px;
    box-sizing: border-box;
    border-radius: ${p => p.noradius ? `0` : `16px`};
    @media(max-width: 767px){
        padding: 32px 24px;
        width: 100%;
    }
`;


export const FormTitle = styled.div.attrs({
})`
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    color: ${props => props.theme.palette.colors.text};
`;

export const SuccessText = styled.div.attrs({
})`
    max-width: 340px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.55;
    text-align: center;
    color: ${props => props.theme.palette.colors.muted};
`;
